import { createFileRoute, Outlet } from '@tanstack/react-router';

import Layout from '@/screens/chat/layout';

export const Route = createFileRoute('/_app/_chat')({
  component: LayoutRoute,
});

function LayoutRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
